import { render } from "./GridCardsServicos.vue?vue&type=template&id=9865083a&scoped=true"
import script from "./GridCardsServicos.vue?vue&type=script&lang=js"
export * from "./GridCardsServicos.vue?vue&type=script&lang=js"

import "./GridCardsServicos.vue?vue&type=style&index=0&id=9865083a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9865083a"]])

export default __exports__